import { useContext } from "react";
import { QuestionnaireContext } from "@Totum/QuestionnaireBuilder/State/provider";

export const useCurrentQuestionnaireId = (): [string | undefined, (questionnaireId?: string | undefined) => void] => {
    const { currentQuestionnaireId, setCurrentQuestionnaireId } = useContext(QuestionnaireContext);

    return [currentQuestionnaireId, setCurrentQuestionnaireId];
};

export default useCurrentQuestionnaireId;
